import React, { Component } from "react";
import ReactDOM from "react-dom";

class WinnerSliderItem extends Component {
  render() {
    const { date, winners } = this.props;

    return (
      <>
        <div className="carousel-cell">
          <div className="winner-slider-item">
            <div className="winner-slider-item-a">Pemenang {date}</div>
            <ul>
              {winners.map((winner, idx) => (
                <li key={idx}>{winner}</li>
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  }
}

export default WinnerSliderItem;
